/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FiltersAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconSettings from 'DesignSystem/Svgs/TysiaIconSettings/index'



/** @type {import('Simple/types.js').View} */
export default function FiltersAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/Search/Content/Profiles/Empty/FiltersAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="center"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../Filters/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../Filters/Content'))}
 type="secondary"
 marginTop={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconSettings
{...childProps}
  viewPath={`${viewPath}/TysiaIconSettings`}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 marginLeft={dtSpaceXxs}
 text="Review your filters"
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}